// Shared visual language for the checkout order summary — line items, discount
// chips, divider, and the "total due" block. Used by both B2GOCheckoutSummary and
// InvoicePreview so every checkout renders the summary identically.

export const summaryColors = {
  primary: "#014638",
  primaryDeep: "#165C4E",
  primaryWash: "#DBEFDD",
  yellow: "#F7EE6F",
  cream: "#f7f6f0",
  body: "#151e16",
  secondary: "#776B5D",
  muted: "#9e9e9e",
  border: "#e0e0e0",
  success: "#00BA13",
};

const summaryStyles = {
  line: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 2,
    py: 1.5,
  },
  lineLabel: {
    display: "flex",
    flexDirection: "column",
    gap: 0.375,
    minWidth: 0,
  },
  lineTitle: {
    fontSize: 15,
    color: summaryColors.body,
  },
  lineSub: {
    fontSize: 12.5,
    color: summaryColors.secondary,
  },
  lineAmount: {
    fontSize: 15,
    fontWeight: 600,
    whiteSpace: "nowrap",
    color: summaryColors.body,
  },
  lineAmountNeg: {
    fontSize: 15,
    fontWeight: 600,
    whiteSpace: "nowrap",
    color: summaryColors.success,
  },
  lineAmountFree: {
    fontSize: 15,
    whiteSpace: "nowrap",
    color: summaryColors.secondary,
  },
  promoChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: 1,
    backgroundColor: summaryColors.primaryWash,
    color: summaryColors.primaryDeep,
    borderRadius: "8px",
    px: 1.25,
    py: 0.75,
    fontSize: 12.5,
    fontWeight: 600,
    border: "none",
    textTransform: "none",
    "&:hover": {
      backgroundColor: summaryColors.primaryWash,
    },
  },
  divider: {
    borderColor: summaryColors.border,
    my: 1,
  },
  totalLabel: {
    fontWeight: 600,
    fontSize: 16,
    color: summaryColors.body,
  },
  totalCurrencyPrefix: {
    fontSize: 16,
    fontWeight: 600,
    color: summaryColors.secondary,
  },
  totalAmount: {
    fontSize: 30,
    fontWeight: 700,
    lineHeight: 1,
    color: summaryColors.body,
  },
  totalCurrencySuffix: {
    fontSize: 13,
    fontWeight: 600,
    color: summaryColors.muted,
    ml: 0.5,
    textTransform: "uppercase",
  },
  wasPrice: {
    fontSize: 14,
    color: summaryColors.muted,
    textDecoration: "line-through",
  },
  saveBadge: {
    backgroundColor: summaryColors.primaryWash,
    color: summaryColors.success,
    fontWeight: 600,
    fontSize: 12,
    px: 1.125,
    py: 0.375,
    borderRadius: "6px",
  },
} as const;

export default summaryStyles;
